<template>
  <div class="question-wrap" ref="questionWrapRef">
    <div class="question-wrap-left" v-if="qaType == '1'">
      <el-scrollbar always>
        <el-menu :default-active="taxActive" @select="menuSelect">
          <el-tooltip :content="title" placement="right">
            <el-text truncated>{{ title }}</el-text>
          </el-tooltip>

          <el-menu-item-group>
            <el-menu-item v-for="(item, index) of taxList" :key="index" :index="item.type">
              <el-text truncated>{{ item.title }}</el-text>
            </el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </el-scrollbar>
    </div>

    <div class="question-wrap-right">
      <div v-if="qaType != '1'" style="display: flex; flex-direction: row-reverse; padding: 5px 10px 5px 0">
        <el-button plain style="margin-left: 15px" @click="emit('save')" type="primary">暂存</el-button>
        <el-button plain type="primary">上传附送资料</el-button>
      </div>
      <el-scrollbar class="el-scrollbar-question-wrap-right" always>
        <component :is="view" ref="viewRef" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
// 3.填报增值税及附加税（一般纳税人）
import { nextTick, toRaw } from "vue";
import { ElMessage } from "element-plus";
import { cloneDeep } from "lodash";

import tax31 from "./cmp/tax31.vue";
import tax32 from "./cmp/tax32.vue";
import tax33 from "./cmp/tax33.vue";
import tax34 from "./cmp/tax34.vue";
import tax35 from "./cmp/tax35.vue";
import tax36 from "./cmp/tax36.vue";
import tax37 from "./cmp/tax37.vue";

const props = defineProps({
  qaType: {
    // 页面类型，默认为1即原始的设置题目，通过菜单切题页面。 其他情况为组件名称即： tax31,tax32,tax33,tax34等
    type: String,
    default: "1",
  },
});

watch(
  () => props.qaType,
  (newVal) => {
    if (newVal == "1") {
      return;
    }
    //nextTick(() => {
    menuSelect(newVal);
    //});
  },
  { immediate: true }
);

const emit = defineEmits(["save", "taxSave"]);

const viewRef = ref();
const isDev = ref(import.meta.env.DEV);
const isSet = ref(location.search.includes("isSet=111"));
const title = ref("3.填报增值税及附加税（一般纳税人）");
const taxList = ref([
  {
    title: "3.1增值税及附加税费申报表(一般纳税人适用)",
    type: "tax31",
  },
  {
    title: "3.2增值税及附加税费申报表附列资料（一）",
    type: "tax32",
  },
  {
    title: "3.3增值税及附加税费申报表附列资料（二）",
    type: "tax33",
  },
  {
    title: "3.4增值税及附加税费申报表附列资料（三）",
    type: "tax34",
  },

  {
    title: "3.5增值税及附加税费申报表附列资料（四）",
    type: "tax35",
  },
  {
    title: "3.6增值税及附加税费申报表（一般纳税人适用）附列资料（五）",
    type: "tax36",
  },
  {
    title: "3.7增值税减免税申报明细表",
    type: "tax37",
  },
]);
const taxActive = ref("tax31");
const view = shallowRef(null);
const views = {
  tax31,
  tax32,
  tax33,
  tax34,
  tax35,
  tax36,
  tax37,
};
view.value = views[taxActive.value];

const mode = ref(null);
const taxDataAll = ref({
  tax31: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(41, 4),
      // 考题设置数据
      // 考题设置数据 - 数字数据
      v11x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v12x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v25x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v34x1: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax32: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(22, 14),
      // 考题设置数据
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x5: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax33: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(40, 3),
      // 考题设置数据
      // 考题设置数据 - 数字数据
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v37x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v37x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v37x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v16x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v20x1: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax34: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(8, 6),
      // 考题设置数据
    },
  },
  tax35: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(8, 6),
      // 考题设置数据
    },
  },
  tax36: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(11, 13),
      // 选择框数据
      v1x4: {
        value: "0.07",
      },
      v2x4: {
        value: "0.03",
      },
      v3x4: {
        value: "0.02",
      },
      // 减征比例数据
      v1x8: {
        value: 0,
      },
      v2x8: {
        value: 0,
      },
      v3x8: {
        value: 0,
      },
      // 单选数据
      v11x3: {
        value: "1",
      },
      // 考题设置数据
      // 考题设置数据 单选数据
      v11x1: {
        value: "",
        answer: null,
        score: null,
      },
      v11x2: {
        value: "",
        answer: null,
        score: null,
      },
      // 测试关联数据
      // v1x1: {
      //   value: 1000,
      // },
      // v2x1: {
      //   value: 2000,
      // },
      // v3x1: {
      //   value: 3000,
      // },
    },
  },
  tax37: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(14, 6),
      // 选择框数据
      v2x6: {
        value: "0",
      },
      v3x6: {
        value: "0",
      },
      v4x6: {
        value: "0",
      },
      v5x6: {
        value: "0",
      },
      v6x6: {
        value: "0",
      },
      v10x6: {
        value: "0",
      },
      v11x6: {
        value: "0",
      },
      v12x6: {
        value: "0",
      },
      v13x6: {
        value: "0",
      },
      v14x6: {
        value: "0",
      },
    },
  },
});
// 初始化
const taxInit = (options = {}) => {
  nextTick(() => {
    try {
      // 合并数据
      mode.value = options.mode;
      if (options.taxDataAll) {
        taxDataAll.value = options.taxDataAll;
      }

      // 当前税表数据
      const taxData = taxDataAll.value[taxActive.value];
      console.log("初始化数据", {
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
      // 初始化
      viewRef.value.init({
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
    } catch (e) {
      console.log(e);
    }
  });
};
// 切换税表
const menuSelect = (value) => {
  // 暂存
  if (mode.value == 1) {
    taxSave(1);
  } else {
    taxSave(2);
    emit("taxSave", { showLoading: false });
  }
  taxActive.value = value;
  view.value = views[value];
};
// 合并选项 合并选项操作只做一次
const taxInitOptionsExtendDone = ref(false);
const taxInitOptionsExtend = (options) => {
  if (!taxInitOptionsExtendDone.value) {
    mode.value = options.mode;
    if (options.taxDataAll) {
      taxDataAll.value = options.taxDataAll;
    }

    taxInitOptionsExtendDone.value = true;
  }
};
// 保存
const taxSave = (type = 1) => {
  // type
  // 1 暂存 不更新填写状态 不根据联表映射规则更新其他tax数据 不发送给后端
  // 2 保存 更新填写状态 根据联表映射规则更新其他tax数据 发送给后端
  console.log(`${["临时", "正式"][type - 1]}保存`);
  try {
    const getData = viewRef.value.getData;

    if (typeof getData === "function" && getData()) {
      // 1
      console.log("当前保存表格为", taxActive.value);
      // 2
      const _data = cloneDeep(getData());
      console.log("当前保存表格数据为", _data);
      // 3
      const _taxDataAll = cloneDeep(toRaw(taxDataAll.value));
      console.log("当前所有表格数据为", _taxDataAll);
      // 4
      _taxDataAll[taxActive.value].data = _data;
      console.log("更新当前保存表格数据到所有表格数据", _taxDataAll);

      if (type == 2) {
        // 5
        if (mode.value == 1) {
          _taxDataAll[taxActive.value].status = 1;
        }
        console.log("做题模式下，更新填写状态", _taxDataAll);
        // 6
        if ([1, 2, 5].includes(+mode.value)) {
          // ElMessage.warning("todo 做题模式下，根据联表映射规则更新其他tax数据");
          taxDataAllUpdate(taxActive.value, _taxDataAll);
        }
      }

      // 重新初始化
      taxInit({
        mode: mode.value, // 1 做题 2 设置题目 3 查看结果 4 查看答案
        taxDataAll: _taxDataAll, // 只有新建题目不需要传入taxDataAll 修改题目，做题，查看结果都需要传入
      });

      console.log("最终返回数据", _taxDataAll);
      return _taxDataAll;
    }
  } catch (e) {
    console.log(e);
  }
};

const questionWrapRef = ref();
const setHeight = () => {
  const $el = questionWrapRef.value;
  $el.style.height = `calc(100vh - ${$el.getBoundingClientRect().top}px - 10px)`;
};

onMounted(() => {
  setHeight();
});

// 联表做题逻辑
function taxDataAllUpdate(taxActive, taxDataAll) {
  console.log("做题模式下，根据联表映射规则更新其他tax数据", taxActive, taxDataAll);

  const tax32 = () => {
    // tax32保存时 将tax32第1行第10列数值 带入tax31 第11行第1列数值
    taxDataAll.tax31.data.v11x1.value = taxDataAll.tax32.data.v1x10.value;
    // 将tax32第1行第9列数值 带入tax31 第1行第1列数值
    taxDataAll.tax31.data.v1x1.value = taxDataAll.tax32.data.v1x9.value;
  };

  const tax33 = () => {
    // tax33保存时 将tax33第12行第3列数值 带入tax31 第12行第1列数值
    taxDataAll.tax31.data.v12x1.value = taxDataAll.tax33.data.v12x3.value;
    // tax33保存时 将tax33第13行第1列数值 带入tax31 第14行第1列数值
    taxDataAll.tax31.data.v14x1.value = taxDataAll.tax33.data.v13x1.value;
  };

  const tax31 = () => {
    // tax31保存时 将tax31第24行第1列数值 带入tax36 第1,2,3行第1列数值
    taxDataAll.tax36.data.v1x1.value = taxDataAll.tax31.data.v24x1.value;
    taxDataAll.tax36.data.v2x1.value = taxDataAll.tax31.data.v24x1.value;
    taxDataAll.tax36.data.v3x1.value = taxDataAll.tax31.data.v24x1.value;
  };

  const tax36 = () => {
    // tax36保存时 将tax36第1,2,3行第13列数值 分别带入tax31 第39,40,41行第1列数值
    taxDataAll.tax31.data.v39x1.value = taxDataAll.tax36.data.v1x13.value;
    taxDataAll.tax31.data.v40x1.value = taxDataAll.tax36.data.v2x13.value;
    taxDataAll.tax31.data.v41x1.value = taxDataAll.tax36.data.v3x13.value;
  };

  const taxDataAllUpdateFn = {
    tax32,
    tax33,
    tax31,
    tax36,
  }[taxActive];

  typeof taxDataAllUpdateFn === "function" && taxDataAllUpdateFn();
}

// 构造数字输入框数据
function createData(x = 10, y = 10) {
  const data = {};
  for (let i = 1; i <= x; i++) {
    for (let j = 1; j <= y; j++) {
      data[`v${i}x${j}`] = {
        value: isSet.value ? +`${i}${j}` : 0,
      };
    }
  }

  return data;
}

defineExpose({
  taxInit,
  taxSave,
});
</script>

<style lang="scss" scoped></style>
